module.exports = __webpack_public_path__ + "img/zenit-logo-white.17eed602.svg";